import React from "react";
import { item } from "../../../data";
import { NavLink } from "react-router-dom";
import "./adminSideBar.scss";
import "@fontsource/roboto";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import CloseIcon from "@mui/icons-material/Close";
import LogoImage from "../../../assets/main-Logo.png";

const AdminSideBar = ({ onClose }) => {
  const navigate = useNavigate();

  const showConfirmAlert = () => {
    return Swal.fire({
      title: "Are you sure?",
      text: "Do you want Sign Out?",
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      customClass: {
        actions: "swal-actions-gap",
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    });
  };

  const handleLogout = async () => {
    const result = await showConfirmAlert();

    if (!result.isConfirmed) return;

    localStorage.removeItem("auth-token");
    navigate("/adminuser");
  };

  return (
    <div className="item-containor">
      <div className="sidebar-header">
        <div className="sidebar-brand">
          <img
            src={LogoImage}
            className="sidebar-logo"
            alt="Cinnamon Lake House Logo"
          />
          <div className="brand-text">
            <span className="brand-accent">Cinnamon</span>
            <span className="brand-sub">Lake House</span>
          </div>
        </div>
        <button
          className="sidebar-close-btn"
          onClick={onClose}
          aria-label="Close Sidebar"
        >
          <CloseIcon />
        </button>
      </div>

      <div className="sidebar-menu-wrapper">
        {item.map((itemSection) => (
          <div className="items" key={itemSection.id}>
            <span className="title" style={{ fontFamily: "Roboto" }}>
              {itemSection.title}
            </span>
            {itemSection.listItem.map((listItem) => (
              <NavLink
                key={listItem.id}
                to={listItem.url}
                end
                className={({ isActive }) =>
                  `listItem ${isActive ? "active" : ""}`
                }
                onClick={onClose}
              >
                <div className="list-icon-wrapper">{listItem.icon}</div>
                <span
                  className="listItemTitle"
                  style={{ fontFamily: "Roboto" }}
                >
                  {listItem.title}
                </span>
              </NavLink>
            ))}
          </div>
        ))}
      </div>

      <div className="logOut-btn">
        <button onClick={handleLogout}>Sign Out</button>
      </div>
    </div>
  );
};

export default AdminSideBar;
